import moment from 'moment'
import 'moment/locale/pt-br'

const format = (date, format = 'L', origin = null) =>
  moment(date, origin).format(format)

const now = (format = 'L') => moment().format(format)

export default { format, now }
